
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 104 99"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.75 47.25h40.5v4.5h-40.5z"}}),_c('path',{attrs:{"d":"M52 13.5A36 36 0 1077.46 24 35.9 35.9 0 0052 13.5zm22.28 58.27a31.5 31.5 0 110-44.55 31.32 31.32 0 010 44.55z"}})])
          )
        }
      }
    